import { render, staticRenderFns } from "./CloseSessionRoulette.vue?vue&type=template&id=0ccc0158&"
import script from "./CloseSessionRoulette.vue?vue&type=script&lang=js&"
export * from "./CloseSessionRoulette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports